import { z } from 'zod';

/** localStorage key for the Old Platform redirect "don't show this again" dismiss flag. */
export const OLD_PLATFORM_REDIRECT_DISMISSED_KEY = 'old_platform_redirect_dismissed';

/** Codec for the dismiss flag — only ever written as `true`. */
export const oldPlatformRedirectDismissedCodec = z.literal(true);

/** Help Centre article explaining the New Platform — target of the redirect modal's "Learn more" link. */
export const OLD_PLATFORM_REDIRECT_LEARN_MORE_URL =
  'https://help.brightlocal.com/hc/en-us/articles/37022165760146-What-is-the-New-Platform';
